import { makeApiCall, makeSelectCall } from "_state/api";
import { queryState } from "./creator";

const queryCustomers = makeApiCall("post", "/customer/query", queryState);

const selectCustomers = makeSelectCall("/customer/query");

export { queryCustomers, selectCustomers };
